<template>
  <div class="cont-throughput-main">
    <div class="left-container">
      <div class="date-refresh-section">
        <div class="from-to-date">
          <DateTimePicker title="From" :showTime="false" :value.sync="selectedFromDate" :errorMessage.sync="fromDateError"/>
          <DateTimePicker title="To" :showTime="false" :value.sync="selectedToDate" :errorMessage.sync="toDateError"/>      
        </div>
    <button @click="refreshClicked">Refresh</button>
  </div>

  <Dropdown  style="margin: 10px 0" placeholder="System" :items="systemItems" itemKey="Application Name" :selectedObject.sync="selectedSystem" :errorMessage.sync="systemError"/>
  <Dropdown style="margin: 10px 0" placeholder="Job Type (Default = ALL)" :items.sync="jobItems" itemKey="Description" :selectedObject.sync="selectedJob" />

  <Filters class="customer-filter" title="Customer" :tableData="customerData" itemKey="Customer Code" itemDesc="Customer Name" @confirmClicked="filterConfirm"/>

  <Tabulator class="table-details" :tableData="tableDetails" multiSelect=1 @rowSelected="tableRowSelected" ref="mTable" :selectedRow.sync="selectedRow" id="mainTable"/>

  </div>

  <div class="right-container">
    <div class="filtered-section">
      <div class="filtered-items">
        <div class="filtered-row">
          <div class="filter-title">Job Date</div>
          <div class="colon-separator">:</div>
          <div class="filter-details" :title="`${filteredFromDate} to ${filteredToDate}`" v-if="filteredFromDate">{{ filteredFromDate }} to {{ filteredToDate }}</div>
        </div>
        <div class="filtered-row">  
          <div class="filter-title">System</div>
          <div class="colon-separator">:</div>
          <div class="filter-details" :title="filteredSystem.System ? filteredSystem.System : ''">{{ filteredSystem.System ? filteredSystem.System : '' }}</div>
        </div>
        <div class="filtered-row">  
          <div class="filter-title">Customer</div>
          <div class="colon-separator">:</div>
          <div class="filter-details" :title="filteredCustomer.length == 0 ? 'ALL' : filteredCustomer.map((s) => { return s['Customer Code'] }).join(', ')">{{ filteredCustomer.length ==0 ? 'ALL' : filteredCustomer.map((s) => { return s['Customer Code'] }).join(',') }}</div>
        </div>
      </div>
      <div class="refresh-section">
        <div v-if="lastRefresh">Last Refreshed : {{ lastRefresh }}</div>
        <div>Job Type : {{ filteredJob ? filteredJob.Description : 'ALL' }}</div>
      </div>
    </div>

    <div class="map-section">

      <div class="pol-section">
        <div class="map-title">LCL Throughput by POL Country (Import)</div>
        <div class="hover-details" v-if="polHoverObject || selectedPol" style="margin-right: 3px">
          <div class="title">{{ polHoverObject ? polHoverObject['country'] : selectedPol['country'] }}</div>
          <table>
            <tr><th> Weight % </th> <td>: {{ polHoverObject ? polHoverObject['GWeightPerc'].toFixed(2) : selectedPol['GWeightPerc'].toFixed(2) }}</td></tr>
            <tr><th> Weight KG </th> <td>: {{ polHoverObject ? polHoverObject['GWeight']:selectedPol['GWeight'] }}</td></tr>
            <tr><th> Measurement </th> <td>: {{ polHoverObject ? polHoverObject['Measurement']:selectedPol['Measurement'] }} m<sup>3</sup></td></tr>
            <tr><th> No of Pkgs </th> <td>: {{ polHoverObject ? polHoverObject['No_Package']:selectedPol['No_Package'] }}</td></tr>
          </table>
        </div>
        <div v-if="polZoom" class="zoom-loading">Loading</div>
        <div id="polMap"></div>
      </div>

      <div class="pod-section">
        <div class="map-title">LCL Throughput by POD Country (Export)</div>
        <div class="hover-details" v-if="podHoverObject || selectedPod">
          <div class="title">{{ podHoverObject ? podHoverObject['country'] : selectedPod['country'] }}</div>
          <table>
            <tr><th> Weight % </th> <td>: {{ podHoverObject ? podHoverObject['GWeightPerc'].toFixed(2) : selectedPod['GWeightPerc'].toFixed(2) }}</td></tr>
            <tr><th> Weight KG </th> <td>: {{ podHoverObject ? podHoverObject['GWeight']:selectedPod['GWeight'] }}</td></tr>
            <tr><th> Measurement </th> <td>: {{ podHoverObject ? podHoverObject['Measurement']:selectedPod['Measurement'] }} m<sup>3</sup></td></tr>
            <tr><th> No of Pkgs </th> <td>: {{ podHoverObject ? podHoverObject['No_Package']:selectedPod['No_Package'] }}</td></tr>
          </table>
        </div>
        <div v-if="podZoom" class="zoom-loading">Loading</div>
        <div id="podMap"></div>
      </div>
    </div>

    <div class="chart-section">
      <div class="pol-chart">
        <img v-if="selectedPol" class="chart-icon" src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png" title="Click on bar to view jobs by port"/>
        <div v-if="!selectedPol" class="empty-chart">No country selected for POL<br/> Click on a country in the map above to view the details</div>
        <div id="polChart">
        </div>
      </div>
      <div class="pod-chart">
        <img v-if="selectedPod" class="chart-icon" src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png" title="Click on bar to view jobs by port"/>
        <div v-if="!selectedPod" class="empty-chart">No country selected for POD<br/> Click on a country in the map above to view the details</div>
        <div id="podChart">
        </div>
      </div>
    </div>
  </div>

  <ContextMenu v-if="showContextMenu" :show.sync="showContextMenu" :position="contextPosition" :contextItems="contextItems"
      @contextSelected="contextSelected" ref="context"/>

    <Loader :isVisible.sync="loading" :loadingText="loadText" />

  </div>
</template>

<script>
/* eslint-disable */
import DateTimePicker from '@/components/DateTimePicker.vue';
import Dropdown from '@/components/Dropdown.vue';
import Filters from '@/components/Filters.vue';
import Loader from '@/components/Loader.vue';
import Tabulator from '@/components/Tabulator';
import ContextMenu from '@/components/ContextMenu.vue';

export default {
  components: {
    DateTimePicker, Dropdown, Filters, Loader, Tabulator, ContextMenu
  },
  data: function() {
    return {
      systemItems: [],
      customerData: [],
      jobItems: [],

      selectedJob: null,
      filteredJob: {},

      selectedSystem: null,
      filteredSystem:{},

      selectedToDate: null,
      selectedFromDate: null,
      filteredToDate: null,
      filteredFromDate: null,

      loading: false,
      loadText: '',

      selectedCustomer: [],
      filteredCustomer:[],

      lastRefresh: '',

      toDateError: '',
      fromDateError: '',
      systemError: '',

      podHoverObject: null,
      polHoverObject: null,
      selectedPod: null,
      selectedPol: null,

      tableDetails: [],
      selectedRow: [],

      showContextMenu: false,
      contextItems: ['POD LCL jobs for [PORT]'],
      contextPosition: [100, 100],

      podMap: {},
      polMap: {},

      mapOptions: { attributionControl: false },

      polTitle: '',
      podTitle: '',
      mapGeoJson: {},
      podGeoJson: null,
      polGeoJson: null,
      selectedPolMap: null,
      selectedPodMap: null,

      allPOLLayers: null,
      allPODLayers: null,

      polZoom: false,
      podZoom: false,

      currentPOL: null,
      currentPOD: null,
      selectrow: false,
      fromTable: false,

      allCountries: [],
    }
  },
  props: {
  },
  methods: {
    getJobs: async function(){
      this.selectedJob = '';
      this.jobItems = await this.$apiCallV2(`/ContainerThroughput/GetListMaster?masterFile=jobtype&modul=${this.selectedSystem.System.trim()}`);

      for(var a=0; a < this.jobItems.length; a++){
        this.jobItems[a]['Description'] = this.jobItems[a]['Description'].toUpperCase();
      }

      this.jobItems.unshift({'Description':'ALL', 'Job Type':''});

    },
    filterConfirm: function(items){
      this.selectedCustomer = items;
    },
    refreshClicked: async function(){
      if (!this.checkError()){
        return;
      }
      $('#polChart').html('');
      $('#podChart').html('');

      this.selectedPol = '';
      this.selectedPod = '';
      this.podHoverObject ='';
      this.polHoverObject = '';


      this.filteredToDate = this.$dateTime.getDateTime(this.selectedToDate, 'yyyy-MM-dd');
      this.filteredFromDate = this.$dateTime.getDateTime(this. selectedFromDate, 'yyyy-MM-dd');
      this.filteredSystem = this.selectedSystem;
      this.filteredCustomer = this.selectedCustomer;
      this.lastRefresh = this.$dateTime.getDateTime( new Date(), 'dd/MM/yyyy HH:mm');

      this.jobItems = await this.$apiCallV2(`/ContainerThroughput/GetListMaster?masterFile=jobtype&modul=${this.filteredSystem.System.trim()}`);

      for(var a=0; a < this.jobItems.length; a++){
        this.jobItems[a]['Description'] = this.jobItems[a]['Description'].toUpperCase();
      }

      this.jobItems.unshift({'Description':'ALL', 'Job Type':''});

      this.filteredJob = this.selectedJob;

      try{
        var dataToPost = {
        'startdate': this.filteredFromDate,
        'enddate': this.filteredToDate,
        'rpttype': '',
        'system':this.filteredSystem.System ? this.filteredSystem.System.trim() : '',
        'jobtype': this.filteredJob ? this.filteredJob['Job Type'] : '',
        'customerarray' : this.filteredCustomer.length == 0 ? '' : this.filteredCustomer.map((c) => {return c['Customer Code'] }).join(',')
      }

      this.loading = true;

      this.loadText = 'Getting POL';
      dataToPost.rpttype = 'BY_POL';
      var POL = await this.$apiCallV2('/LCLThroughputPOLPOD/GetContLessAnalysis', dataToPost);

      console.log(POL);

      this.polGeoJson = {
        type: 'FeatureCollection',
        features: this.createGeoJson(POL, 'POL')
      };

      this.loadPOLMap();

      this.$nextTick(async() => {
        this.loadText = 'Getting POD';
        dataToPost.rpttype = 'BY_POD';
        var POD =await this.$apiCallV2('/LCLThroughputPOLPOD/GetContLessAnalysis', dataToPost);

         console.log(POD);

        this.podGeoJson = {
          type: 'FeatureCollection',
          features: this.createGeoJson(POD, 'POD')
        };
        this.loadPODMap();

        this.$nextTick(() => {
          this.loading = false;
        })
      });
  

      }catch(e){console.log(e)}
      
    },
    checkError: function() {
      var errorCount = 0;

      if (!this.selectedFromDate){
        errorCount++;
        this.fromDateError = 'Date is required!';
      }
      if (!this.selectedToDate){
        errorCount++;
        this.toDateError = 'Date is required!';
      }
      if (!this.selectedSystem){
        errorCount++;
        this.systemError = 'System is required!';
      }

      return errorCount == 0;
    },
    //Map functions
    loadPODMap: function() {
      document.getElementById('podMap').outerHTML = '<div id="podMap" class="map-style"></div>';
      this.podMap = L.map('podMap', this.mapOptions).setView([0,0], 1);

      L.tileLayer(
        'https://api.maptiler.com/maps/voyager/{z}/{x}/{y}.png?key=bXzh6APCqEBOILcI2X7G'
      ).addTo(this.podMap);

      this.mapGeoJson = L.geoJson(this.podGeoJson, {
        style: this.mapStyling,
        onEachFeature: this.mapFeatures
      }).addTo(this.podMap);

      this.podMap.on('zoomstart', () => {
        if (!this.podZoom) {
          this.podZoom = true;
        }
      });
      this.podMap.on('zoomend', () => { this.podZoom = false });

      this.podMap.eachLayer((l) => {
        if (l instanceof L.TileLayer){
          if (l._map._renderer){
            this.allPODLayers = l._map._renderer._layers;
          }
        }
      });
    },
    loadPOLMap: function(){
      document.getElementById('polMap').outerHTML = '<div id="polMap" class="map-style"></div>';
      this.polMap = L.map('polMap', this.mapOptions).setView([0,0],1);

      L.tileLayer(
        'https://api.maptiler.com/maps/voyager/{z}/{x}/{y}.png?key=bXzh6APCqEBOILcI2X7G'
      ).addTo(this.polMap);

      this.mapGeoJson = L.geoJson(this.polGeoJson, {
        style: this.mapStyling,
        onEachFeature: this.mapFeatures
      }).addTo(this.polMap);
      
      this.polMap.on('zoomstart', () => {
        if (!this.polZoom) {
          this.polZoom = true;
        }
      });
      this.polMap.on('zoomend', () => { this.polZoom = false });
      
      this.polMap.eachLayer((l) => {
        if (l instanceof L.TileLayer) {
          if (l._map._renderer) {
            this.allPOLLayers = l._map._renderer._layers;
          }
        }
      });
    },
    mapStyling: function(f){
      var opac = (f.properties.opac.toFixed(2) / 100).toFixed(2);
      return{
        fillColor: `rgba(185, 119, 14, ${opac <= 0.15 ? 0.15 : opac})`,
        weight: 1,
        opacity: 1,
        color: 'transparent',
        fillOpacity: 1
      }
    },
    mapFeatures: function(feature, layer){
      layer.on({
        mouseover: this.countryMouseIn,
        mouseout: this.countryMouseOut,
        click: this.countryClicked
      });
    },
    countryMouseIn: function(e){
      var layer = e.target;

      if(layer.options.color == 'blue'){
        return;
      }

      layer.setStyle({
        weight: 1,
        color: 'black'
      });

      if(layer.feature.properties.rpttype == 'POL'){
        this.polHoverObject = layer.feature.properties;
      }else{
        this.podHoverObject = layer.feature.properties;
      }

      if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge){
        layer.bringToFront();
      }
    },
    countryMouseOut: function(e){
      if (e.target.options.color == 'black'){
        this.mapGeoJson.resetStyle(e.target);
      }

      this.polHoverObject = null;
      this.podHoverObject = null;
    },
    countryClicked: function(e) {
      console.log('data received countryClicked')
      console.log(e);
      var layer = e.target;
      var countryDetails = e.target.feature.properties;

      //to deselect item
      if (layer.options.color == 'blue') {
        this.mapGeoJson.resetStyle(layer);
        console.log('deleting stuff');
        console.log(layer);

        if (countryDetails.rpttype == 'POL') {
          this.currentPOL = null; 
          this.polMap.closePopup();
          this.selectedPol = null;
          this.selectedPolMap = null;
          this.polMap.setView([0, 0], 1);
          $('#polChart').html('');
        } else {
          this.currentPOD = null;
          this.podMap.closePopup();
          this.selectedPod = null;
          this.selectedPodMap = null;
          this.podMap.setView([0, 0], 1);
          $('#podChart').html('');
        }

        if (!this.currentPOL && !this.currentPOD) {
          this.$refs['mTable'].clearAllSelectedRow();
        }
        
        return;
      }

      layer.setStyle({
        weight: 1,
        color: 'blue'
      });
 
      if (countryDetails.rpttype == 'POL'){
        console.log(countryDetails);
        this.currentPOL = e;
        this.polMap.closePopup();

        this.polMap.fitBounds(layer.getBounds());
        this.selectedPol = countryDetails;
        this.selectedPolMap = e.target;
        this.createBarChart('#polChart', `Total LCL Weight (KG) by POL in ${countryDetails.country}`, countryDetails.details);

        var lPopup = L.popup({ closeOnClick: false, autoClose: false, closeButton: false });
        var popupContent = `<p class="pol-drill-through">POL LCL summary<br /> by customer for ${countryDetails.country}</p>
        <img class="popup-icon" src="https://dsmapi.logistics.systems/dsm6gicons/open-in-new-tab.png" title="View LCL job summary"/>`;

        if (e.latlng) {
          lPopup.setLatLng([e.latlng.lat, e.latlng.lng]).setContent(popupContent).openOn(this.polMap);
        } else {
          var center = layer.getBounds().getCenter();
          lPopup.setLatLng([center.lat, center.lng]).setContent(popupContent).openOn(this.polMap);
        }

        var polDrillThrough = $('.pol-drill-through');
        polDrillThrough.click(() => { this.drillThroughClicked('BY_POL_CSGN', countryDetails) });
      }else{
        console.log(countryDetails);
        this.currentPOD = e;
        this.podMap.closePopup();
        /* if (this.selectedPodMap){
          this.mapGeoJson.resetStyle(this.selectedPodMap);
        } */
        this.podMap.fitBounds(layer.getBounds());
        this.selectedPod = countryDetails;
        this.selectedPodMap = e.target;
        this.createBarChart('#podChart', `Total LCL Weight (KG) by POD in ${countryDetails.country}`, countryDetails.details);

        var lPopup = L.popup({ closeOnClick: false, autoClose: false, closeButton: false });
        var popupContent = `<p class="pod-drill-through">POD LCL summary<br />by customer for ${countryDetails.country}</p>
        <img class="popup-icon" src="https://dsmapi.logistics.systems/dsm6gicons/open-in-new-tab.png" title="View LCL job summary"/>`;

        if (e.latlng) {
          lPopup.setLatLng([e.latlng.lat, e.latlng.lng]).setContent(popupContent).openOn(this.podMap);
        } else {
          var center = layer.getBounds().getCenter();
          lPopup.setLatLng([center.lat, center.lng]).setContent(popupContent).openOn(this.podMap);
        }

        var podDrillThrough = $('.pod-drill-through');
        podDrillThrough.click(() => { this.drillThroughClicked('BY_POD_SHPR', countryDetails) });
      }   

      
    },
    drillThroughClicked: async function(rpttype, country, port){
      this.loadText = 'Getting Details';
      this.loading = true;

      var dataToPost = {
        'startdate': this.filteredFromDate,
        'enddate': this.filteredToDate,
        'rpttype': rpttype,
        'system' : this.filteredSystem.System ? this.filteredSystem.System.trim() : '',
        'jobtype': this.filteredJob ? this.filteredJob['Job Type'] : '',
        'customerarray': this.filteredCustomer.length == 0 ? '' : this.filteredCustomer.map((c) => {return c['Customer Code']}).join(',')
      }

      if (country) {
        var countryName = country.country;
        var countryCode = country.details[0]['XAxis'];

        var drillThrough = await this.$apiCallV2('/LCLThroughputPOLPOD/GetContLessAnalysis', dataToPost);

        var drillThroughSelectedCountry = drillThrough.filter((d) => {return d['Country Code'] == countryCode});

        sessionStorage.setItem(`LCL Drill Through - ${rpttype == 'BY_POL_CSGN' ? 'POL' : 'POD'} ${countryCode}`, JSON.stringify({ country: countryName, data: drillThroughSelectedCountry }));

        //To be checked
        var drillThroughLink = this.$router.resolve(`/Home/${this.$route.params['user']}/Dashboard/LCL Throughput POL and POD/LCL Drill Through - ${rpttype == 'BY_POL_CSGN' ? 'POL' : 'POD'} ${countryCode}`);
        window.open(drillThroughLink.href, '_blank');
      }

      if(port){
        var drillThrough = await this.$apiCallV2('/LCLThroughputPOLPOD/GetContLessAnalysis', dataToPost);

        var selectedPort = drillThrough.filter((d) => { return d['Port Code'] == port });

        sessionStorage.setItem(`LCL Drill Through - ${rpttype == 'BY_POL_JOB' ? 'POL' : 'POD'} ${port}`, JSON.stringify({ country: '', data: selectedPort, port: port }));

        var drillThroughLink = this.$router.resolve(`/Home/${this.$route.params['user']}/Dashboard/LCL Throughput POL and POD/LCL Drill Through - ${rpttype == 'BY_POL_JOB' ? 'POL' : 'POD'} ${port}`);
        window.open(drillThroughLink.href, '_blank');

      }
      this.loading = false;
    },
    createGeoJson: function(data, type){
      var uniqueCountry = [...new Set(data.map((p) => { return p.XAxis } ))];
      uniqueCountry = uniqueCountry.filter((u) => { return u });
      data = data.filter((d) => { return d.XAxis } );
      var features =[];

      uniqueCountry.forEach((u) => {
        var json = this.allCountries.features.filter((f) => { return f.properties['ISO_A3'].toUpperCase().trim() == u.toUpperCase().trim() });
        if (json.length > 0) {
          var allDetails = data.filter((d) => { return d.XAxis.toUpperCase() == u.toUpperCase() });
          var properties = {
            country: allDetails[0]['Country_Name'],
            GWeightPerc : allDetails.map((a) => { return a.GWeightPerc }).reduce((a,b) => { return a + b }),
            GWeight : allDetails.map((a) => { return a.GWeight }).reduce((a,b) => { return a + b }),
            Measurement : allDetails.map((a) => { return a.Measurement }).reduce((a,b) => { return a + b }),
            No_Package : allDetails.map((a) => { return a.No_Package }).reduce((a,b) => { return a + b }),
            details: allDetails,
            rpttype : type
          };

          features.push({ type: 'Feature', properties: properties, geometry: json[0].geometry });  
        } else {
          var noDetails = data.filter((d) => { return d.XAxis.toUpperCase() == u.toUpperCase() });
          console.log(`Cannot find ${u} - ${JSON.stringify(noDetails)}`);
        }
      });

      var max = Math.max.apply(Math, features.map((f) => { return f.properties['GWeightPerc'] }));
      var toHundredPercent = 100 / max.toFixed(2);

      features.forEach((f) => { f.properties.opac = f.properties['GWeightPerc'] * toHundredPercent });
      var finalFeatures = features.filter((f) => { return f });

      if (type =='POL'){
        this.tableDetails = [];

        finalFeatures.forEach((f) => {
          this.tableDetails.push({ '#' : '', Country: f.properties.country.trim(), 'POL %': f.properties.GWeightPerc.toFixed(2), 'POD %': '' })
        });
      }else{
        finalFeatures.forEach((f) => {
          var countryExists = this.tableDetails.filter((t) => {return t.Country == f.properties.country.trim() });
          if (countryExists.length > 0) {
            countryExists[0]['POD %'] = f.properties.GWeightPerc.toFixed(2);
          }else{
            this.tableDetails.push({ '#':'', Country: f.properties.country.trim(), 'POL %': '', 'POD %': f.properties.GWeightPerc.toFixed(2) });
          }
        });

        this.tableDetails.sort((a,b) => { return a.Country > b.Country ? 1 : -1 });
        var index = 1;
        this.tableDetails.forEach((t) => { t['#'] = index++ });
        //this.tableDetails.splice(0,0, { '#': '0', Country: 'String', 'POL %': 'Number', 'POD %': 'Number' });

      }

      return finalFeatures;
    },
    tableRowSelected: function(row){     
      console.log('show Row');
      console.log(row);

      console.log('show POL');
      console.log(this.currentPOL);

      console.log('show POD');
      console.log(this.currentPOD);

       if (row == null) {
        console.log('got null Row');
        if (this.currentPOD) {
          this.countryClicked(this.currentPOD); 
        } 
        if (this.currentPOL) {
          this.countryClicked(this.currentPOL); 
        }
        return;
       }

          if (row['POL %']) {
            console.log(row['POL %']);
          // this.polZoom = true;
          console.log('setting pol');
          var polLayer = Object.keys(this.allPOLLayers).filter((l) => { return this.allPOLLayers[l].feature.properties.country.trim() == row.Country });
          var countryObjectPOL = { target: this.allPOLLayers[polLayer[0]] };
          this.countryClicked(countryObjectPOL);
          
          } else if(this.currentPOL){
            console.log('clearing pol');
            this.countryClicked(this.currentPOL);

          }
          
          if (row['POD %']) {
            console.log(row['POD %']);
            // this.podZoom = true;
            console.log('setting pod');
              var podLayer = Object.keys(this.allPODLayers).filter((l) => { return this.allPODLayers[l].feature.properties.country.trim() == row.Country });
              var countryObjectPOD = { target: this.allPODLayers[podLayer[0]] };
              this.countryClicked(countryObjectPOD);
              
          } else if(this.currentPOD) {
            console.log('clearing pod');
            this.countryClicked(this.currentPOD);

          }
          return;
          
      
    },
    //bar chart method
    createBarChart: function(id, title, data) {
      $(id).html('');

      var ctBarID = id == '#polChart' ? 'isPOL' : 'isPOD';
      
      var options = {
        axisY: {
          onlyInteger: true
        },
        classNames: {
          bar: `ct-bar ${ctBarID}`
        },
        plugins: [
            Chartist.plugins.ctBarLabels({
              position: {
                x: function (data) {
                  return data.x1 + 60
                },
              },

              labelInterpolationFnc: function (text) {
                return text + 'KG'
              }
            })
          ]
      };

      var barChart = new Chartist.Bar(id, {
        labels: data.map((d) => { return d['XAxisDesc'] }),
        series: [
          data.map((d) => { return { meta: `LCLs|${d['XAxisDesc']}|${d['Port_Name']}`, value: d['GWeight'] } })
        ]
      }, options
      
      );

      var title = $(`<div class="chart-title">${title}</div>`).appendTo($(id));
      var $tooltip = $(`<div class="tooltip tooltip-hidden"></div>`).appendTo($(id));

      barChart.on('created', () => {
        var meta = $(this).attr('ct:meta');
        $('.ct-series-a').children('.ct-bar').addClass('bar-20-color');
        $('.ct-series-b').children('.ct-bar').addClass('bar-40-color');
        
        $('.ct-label').css({ color: 'black' });

        $('.ct-horizontal').css({
          transform: 'translate(calc(-50% - 5px)) rotate(-90deg)',
          fontSize: '9px',
          justifyContent: 'flex-end',
          transformOrigin: '100% 0'
        });

        $(`.${ctBarID}`).on('mouseover', function() {
          var meta = $(this).attr('ct:meta');
          $tooltip.html(`<span>${meta.split('|')[1]}</span><br /><span>${meta.split('|')[2]}</span><br /><br /><span>${meta.split('|')[0]}: ${$(this).attr('ct:value')}</span>`);
          $tooltip.removeClass('tooltip-hidden');
          $(`.${ctBarID}`).css({
            cursor: "pointer",
          });
          
        });

        $(`.${ctBarID}`).on('mouseout', function() {
          $tooltip.addClass('tooltip-hidden');
        });

        $(`.${ctBarID}`).on('mousemove', function(e) {
          $tooltip.css({
            left: e.offsetX,
            top: e.offsetY - 20
          });
        });
        

        var mainContainer = this;

        $(`.${ctBarID}`).on('click', function(e) {
          var meta = $(this).attr('ct:meta');
          mainContainer.showContextMenu = true;

          var portName = meta.split('|');
          var selectedCountry = ctBarID == 'isPOL' ? mainContainer.selectedPol : mainContainer.selectedPod;

          mainContainer.contextItems = [ `${ctBarID == 'isPOL' ? 'POL' : 'POD'} LCL jobs for ${portName[1]} (${selectedCountry.country.trim()})` ];     
         
          mainContainer.$nextTick(() => {
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight + 50), e.clientX - 150 ];
          });
        });
      });
    },
    contextSelected: function(item) {
      this.drillThroughClicked(item.includes('POL') ? 'BY_POL_JOB' : 'BY_POD_JOB', null, item.split(' ')[4]);    
    }

  },
  async mounted() {
    this.loading = true;

    this.loadText = 'Getting Systems';
    this.systemItems = await this.$apiCallV2('/LCLThroughputPOLPOD/GetListMaster?master=SYSTEM&modul=null');

    this.loadText = 'Getting Customers';
    this.customerData = await this.$apiCallV2('/LCLThroughputPOLPOD/GetListMaster?master=BILLCUSTNAME&modul=null');

    this.loadText = 'Getting World Geo';
    this.allCountries = await this.$apiCallV2('/ContainerThroughputPOLPOD/GetWorldGeoJson');

    var year = new Date().getFullYear();
    var month = new Date().getMonth();
    var lastDate = new Date(year, month + 1, 0).getDate();

    this.selectedFromDate = new Date(year, month, 1);
    this.selectedToDate = new Date(year, month, lastDate);
    this.selectedSystem = this.systemItems[0];
    
    var tempArray = [{'Description':'ALL','Job Type': ''}];


    this.loading = false;

    this.refreshClicked();

  },
  watch: {
    selectedSystem: function (val) {
      this.getJobs();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.ct-label {
    font-weight: bold;
}

.cont-throughput-main {
  display: flex;
  padding: 5px 45px;
  font-size: 12px;

  > .left-container {
    height: 100%;
    min-width: 250px;
    max-width: 300px;
    padding: 5px;
    background-color: white;
    // border: 1px solid rgb(200,200,200);
    border-radius: 5px;
    margin-right: 5px;

    > .date-refresh-section {
      display: flex;
      align-items: center;

      > .from-to-date {
        flex-grow: 1;
      }

      > button {
        height: fit-content;
      }
    }

    > .customer-filter {
      height: calc(100% - 424px);
    }

    > .table-details {
      height: 250px;
    } 
  }

  > .right-container {
    width: calc(100% - 250px);
    height: 100%;
    display: flex;
    flex-direction: column;

    > .filtered-section {
      width: 100%;  
      background-color: white;
      border-radius: 5px;
      padding: 5px;
      position: relative;
      display: flex;
      align-items: center;

      > .filtered-items {
        width: calc(100% - 250px);

        > .filtered-row {
          display: flex;
          align-items: center;

          > .filter-title {
            width: 70px;
          }

          > .colon-separator {
            margin: 0 5px;
          }

          > .filter-details {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      
      > .refresh-section {
        height: 100%;
        min-width: 250px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        > button {
          width: fit-content;
          margin: 3px 0;
        }
      }
    }

    > .map-section {
      margin-top: 5px;
      display: flex;
      height: calc(100% + 200px);
      width: 100%;

      > .pod-section, > .pol-section {
        width: 50%;
        height: 100%;
        position: relative;
        background-color: white;
        border-radius: 5px;
        overflow: hidden;

        > .map-title {
          font-weight: bold;
          text-align: center;
          width: 100%;
          height: 20px;
        }

        > .zoom-loading {
          position: absolute;
          z-index: 1001;
          background-color: rgba(0,0,0,0.3);
          color: white;
          height: calc(100% - 20px);
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        > .hover-details {
          background-color: white;
          display: flex;
          flex-direction: column;
          width: fit-content;
          position: absolute;
          top: 23px;
          right: 3px;
          padding: 5px;
          border-radius: 3px;
          border: 1px solid rgb(200,200,200);
          z-index: 600;

          > .title {
            font-weight: bold;
            text-align: center;
          }
        }
      }

      > .pol-section {
        margin-right: 3px;
      }

      > .pod-section {
        margin-left: 3px;
      }
    }

    > .chart-section {
      height: 50%;
      width: 100%;
      display: flex;
      margin-top: 5px;

      > .pol-chart, > .pod-chart {
        width: 50%;
        height: 100%;
        position: relative;
        background-color: white;
        border-radius: 5px;

        > .empty-chart {
          position: absolute;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: bolder;
          font-size: 10px;
          text-align: center;
        }
      }

      > .pol-chart {
        margin-right: 3px;
      }

      > .pod-chart {
        margin-left: 3px;
      }
    }
  }
}

</style>

<style lang="scss">

img.barchart-icon{
  width: 20px;
  height: 20px;
  position:  absolute;
  top: 17px;
  right: 7px;
}

img.chart-icon{
  width: 25px;
  height: 25px;
  position:  absolute;
  top: 15px;
  right: 7px;
  z-index: 600;
}

img.popup-icon{
  width: 20px;
  height: 20px;
  position:  absolute;
  top: 4px;
  right: 7px;
}

.bar-20-color {
  stroke: blue !important;
  cursor: pointer;
}

.bar-40-color {
  stroke: aqua !important;
    cursor: pointer;

}

.map-style {
  width: 100%;
  height: calc(100% - 20px);
}

.chart-title {
  // position: absolute;
  // top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 30px;
  text-align: center;
  font-weight: bold;
}

.pol-drill-through, .pod-drill-through {
  font-weight: bold;
  cursor: pointer;
  text-align: center;
}

.leaflet-popup-content-wrapper, .leaflet-popup-tip {
  background-color: #383838;
  color: white;
  &:hover{
    background: rgb(87, 84, 84);
    cursor:pointer;
  }
}

.ct-label {
    color: Black !important;
    font-weight: bold;
    font-size: 10px;
    font-family: "Lucida Sans Unicode", "Lucida Grande", sans-serif;
}


</style>

